module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 14
// module chunks = 0